module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "red white--text",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n    Diese Seite ist bisher statisch und befindet sich noch im Aufbau!\n    "), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, _vm._l((_vm.eintrage), function(eintrag) {
    return _c('v-col', {
      key: eintrag.id,
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(eintrag.titel) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          " + _vm._s(eintrag.beschreibung) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-action', _vm._l((eintrag.tags), function(tag) {
      return _c('v-chip', {
        key: tag,
        staticClass: "pa-2 ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
    }), 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf796ad4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/lexikon.vue
// module id = 808
// module chunks = 15